import initAxios from "./initAxios";
import getEnvironDomainHost from "../utils/getEnvironDomainHost";

class EnablerApi {
  constructor() {
    const host = getEnvironDomainHost();

    this.axios = initAxios({ baseURL: host, withCredentials: true });
  }

  getFeatures = () => this.axios.get("/webapi/enabler/v1.0/features");

  setView = (id) => this.axios.post(`/webapi/enabler/v1.0/features/${id}/view`);

  // sendReject = () => this.axios.post("/api/nps/Reject");

  // sendPoint = (point) => this.axios.post(`/api/nps/Point/?point=${point}`);

  // sendAnswer = (text) =>
  //   this.axios.post("/api/nps/Comment", JSON.stringify(text));
}

export default EnablerApi;
